// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./BDT_global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.battery-container {
    padding: 20px;
    border-radius: 10px;
    background-color: aliceblue;
    opacity: 0;
    animation: fadeIn 0.5s ease-in-out 100ms forwards;
}

.cell {
    border: 1px solid gray;
    border-radius: 3px;
    /* width: 5.4rem; */
    height: 15px;
    padding: 0.1rem;
    font-size: 0.5rem;
    color: var(--text-color-3);
}

.module-heading {
    background-color: #E0E0E0;
    font-size: 22px;
    padding: 2px;
    font-weight: bolder;
    color: #0E3157;
}

.curser-pointer {
    cursor: pointer;
}

.display-info-div {
    padding: 5px;
    border-radius: 5px;
    height: auto;
}

.display-info-div {
    position: relative;
    font-size: 12px;
    color: #333;
    opacity: 0;
    animation: fadeIn 1s ease-in-out 0.5s forwards;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

/* .custom-tooltip-class .tooltip-inner {
    background-color: #304356 !important;
    color: white !important;
    opacity: 0.8;
    font-size: 10px;
    padding: 10px;
}

.custom-tooltip-class .tooltip-inner div {
    font-size: 10px;
    display: flex;
    flex-direction: column;
    align-items: start;
} */

.tooltip-inner {
    background-color: #304356 !important;
    color: white !important;
    opacity: 0.8;
    font-size: 10px;
    padding: 10px;
}

.bdt_tooltip div {
    font-size: 8px;
    display: flex;
    flex-direction: column;
    align-items: start;
}
.scroll-container-BDT {
  height: 200px;
  overflow-y: auto;

  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.4) transparent;
}

.scroll-container-BDT::-webkit-scrollbar {
  width: 6px;             
}

.scroll-container-BDT::-webkit-scrollbar-track {
  background: transparent; 
}

.scroll-container-BDT::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/BatteryDigitalTwin_Bus/BDT_battery_Bus.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;IACV,iDAAiD;AACrD;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,UAAU;IACV,8CAA8C;AAClD;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;IACI,oCAAoC;IACpC,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;EACE,aAAa;EACb,gBAAgB;;EAEhB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB","sourcesContent":["@import url('./BDT_global.css');\n\n.battery-container {\n    padding: 20px;\n    border-radius: 10px;\n    background-color: aliceblue;\n    opacity: 0;\n    animation: fadeIn 0.5s ease-in-out 100ms forwards;\n}\n\n.cell {\n    border: 1px solid gray;\n    border-radius: 3px;\n    /* width: 5.4rem; */\n    height: 15px;\n    padding: 0.1rem;\n    font-size: 0.5rem;\n    color: var(--text-color-3);\n}\n\n.module-heading {\n    background-color: #E0E0E0;\n    font-size: 22px;\n    padding: 2px;\n    font-weight: bolder;\n    color: #0E3157;\n}\n\n.curser-pointer {\n    cursor: pointer;\n}\n\n.display-info-div {\n    padding: 5px;\n    border-radius: 5px;\n    height: auto;\n}\n\n.display-info-div {\n    position: relative;\n    font-size: 12px;\n    color: #333;\n    opacity: 0;\n    animation: fadeIn 1s ease-in-out 0.5s forwards;\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* .custom-tooltip-class .tooltip-inner {\n    background-color: #304356 !important;\n    color: white !important;\n    opacity: 0.8;\n    font-size: 10px;\n    padding: 10px;\n}\n\n.custom-tooltip-class .tooltip-inner div {\n    font-size: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n} */\n\n.tooltip-inner {\n    background-color: #304356 !important;\n    color: white !important;\n    opacity: 0.8;\n    font-size: 10px;\n    padding: 10px;\n}\n\n.bdt_tooltip div {\n    font-size: 8px;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n}\n.scroll-container-BDT {\n  height: 200px;\n  overflow-y: auto;\n\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.4) transparent;\n}\n\n.scroll-container-BDT::-webkit-scrollbar {\n  width: 6px;             \n}\n\n.scroll-container-BDT::-webkit-scrollbar-track {\n  background: transparent; \n}\n\n.scroll-container-BDT::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.4);\n  border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
